export default __webpack_public_path__ + "static/1191-95a6143186c317c14e686162268584ca.gif";